import PropTypes from 'prop-types';
import React from "react";

const CircleText = (props) => {
    const m = props.cMargin ?? 0;
    const vb = -m + ' ' + -m + ' ' + (150 + m*2) + ' ' + (150 + m*2);
    return (
        <a onClick={props.clickEvent} >
            <div className={'clickable ' + props.className}>
            <svg xmlns='http://www.w3.org/2000/svg'
                 xmlnsXlink='http://www.w3.org/1999/xlink'
                 viewBox={vb}
                 fill={'currentColor'}
            >   <defs>
                    <path id='halfUp'
                          d='m 15 75 a 35 35 90 0 1 120 0'>
                    </path>
                    <path id='halfDown'
                          d='m 135 75 a 35 35 90 0 1 -120 0'>
                    </path>
                </defs>
                {props.children}
                <text className={props.classText}>
                    <textPath xlinkHref='#halfUp'>
                        {props.sep}{props.title}
                    </textPath>
                    <textPath xlinkHref='#halfDown'>
                        {props.sep}{props.title}
                    </textPath>
                </text>
            </svg>
            </div>
        </a>
    );
}

CircleText.propTypes = {
    title: PropTypes.string.isRequired,
    sep: PropTypes.string,
    className: PropTypes.string.isRequired,
    classText: PropTypes.string.isRequired,
    children: PropTypes.element,
    clickEvent: PropTypes.func.isRequired,
    cMargin: PropTypes.number,
}

CircleText.defaultProps = {
    sep: '',
    cMargin: 0,
    classText: 'font-circle',
}

export default CircleText;
